import { graphql } from "~/lib/graphql";

export const SpeakerblockFragment = graphql(`
  fragment SpeakerblockFragment on SpeakerblockRecord {
    __typename
    id
    compactView
    speaker {
      id
      name
      subtitle
      text(markdown: true)
      image {
        url
        id
        format
        focalPoint {
          x
          y
        }
        width
        height
      }
      employee {
        firstName
        lastName
        slug
        orcid
        profilePicture {
          url
          id
          format
          focalPoint {
            x
            y
          }
          width
          height
        }
      }
    }
  }
`);
